import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "flex flex-col" }
const _hoisted_2 = { class: "justify-center" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_n_auto_complete = _resolveComponent("n-auto-complete")!
  const _component_n_form_item = _resolveComponent("n-form-item")!
  const _component_HosterInvitePerson = _resolveComponent("HosterInvitePerson")!
  const _component_n_scrollbar = _resolveComponent("n-scrollbar")!
  const _component_n_form = _resolveComponent("n-form")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_n_form, null, {
        default: _withCtx(() => [
          _createVNode(_component_n_form_item, {
            "label-placement": "left",
            label: "Email",
            path: ""
          }, {
            default: _withCtx(() => [
              _createVNode(_component_n_auto_complete, {
                options: _ctx.options,
                value: _ctx.valueRef,
                "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.valueRef) = $event)),
                "clear-after-select": "",
                placeholder: "新增邀請對象(Email、姓名、工號、分機)",
                "on-select": _ctx.onSelectPerson,
                "get-show": _ctx.getShow,
                clearable: ""
              }, null, 8, ["options", "value", "on-select", "get-show"])
            ]),
            _: 1
          }),
          _createVNode(_component_n_form_item, null, {
            default: _withCtx(() => [
              _createVNode(_component_n_scrollbar, { style: {"max-height":"400px"} }, {
                default: _withCtx(() => [
                  (_ctx.actionModal == 'I')
                    ? (_openBlock(), _createBlock(_component_HosterInvitePerson, {
                        key: 0,
                        type: 1
                      }))
                    : (_openBlock(), _createBlock(_component_HosterInvitePerson, {
                        key: 1,
                        type: 2
                      }))
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ])
  ]))
}